import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { clamp } from 'lodash';

import { GridEntityConfig, GridParams } from '../grid-types';

export const useLevelIndex = (gridConfig?: GridEntityConfig[]) => {
  const { level } = useParams<GridParams>();

  const upperBound = gridConfig ? Math.max(gridConfig.length - 1, 0) : 0;

  const levelIndex = useMemo(() => {
    if (!level || isNaN(parseInt(level))) {
      return undefined;
    }

    return clamp(parseInt(level), 0, upperBound);
  }, [level, upperBound]);

  return levelIndex;
};
